import NotificationGrantedIcons from '@/icons/NotificationGrantedIcons'
import NotificationOffIcons from '@/icons/NotificationOffIcons'
import useNotificationStore from '@/stores/useNotificationStore'
import { useMemo, useState } from 'react'
import { Popover, Tooltip } from 'vnetwork-ui'
import PopupNotification from './PopupNotification'
import {
    query,
    collection,
    orderBy,
    Timestamp,
    limit,
    where,
    addDoc,
    updateDoc,
    doc,
} from 'firebase/firestore'
import { db } from '@/configs/firebase'
import useCollectionQuery from '@/hooks/useCollectionQuery'
import useAuthStore from '@/stores/useAuthStore'
import { useTranslation } from 'react-i18next'
import NotificationPrimaryIcons from '@/icons/NotificationPrimaryIcons'

export interface NotificationItem {
    body: string
    title: string
    link: string
    read: boolean
    id: string
    created_at: Timestamp
}

const NotificationComp = () => {
    const { notificationPermissionStatus } = useNotificationStore()
    const [showPopoverNotification, setShowPopoverNotification] =
        useState(false)
    const { employee } = useAuthStore()

    const { t } = useTranslation()

    const [limitCount, setLimitCount] = useState(10)

    const { data, error, loading } = useCollectionQuery(
        `notifications-${employee?.employee_id}-${limitCount}`,
        query(
            collection(db, 'notifications'),
            where('employee_ids', 'array-contains-any', [
                employee?.employee_id,
            ]),
            orderBy('created_at', 'desc'),
            limit(limitCount)
        )
    )

    const { data: lastSeen } = useCollectionQuery(
        `last-seen-notifications-${employee?.employee_id}`,
        query(
            collection(db, 'last-seen-notifications'),
            where('employee_id', '==', employee?.employee_id),
            limit(1)
        )
    )

    const lastSeenTimestamp = lastSeen?.docs?.[0]?.data()?.last_seen

    const notifications =
        data?.docs?.map((doc) => ({
            ...(doc?.data() as NotificationItem),
            id: doc.id,
        })) || []

    const handleClosePopup = () => {
        if (notificationPermissionStatus !== 'granted') {
            return Notification.requestPermission()
        }

        setShowPopoverNotification((prev) => !prev)

        if (notificationNotSeenCount <= 0) return

        if (!lastSeen?.docs?.[0]?.id) {
            addDoc(collection(db, 'last-seen-notifications'), {
                employee_id: employee?.employee_id,
                last_seen: Timestamp.now(),
            })
        } else {
            updateDoc(
                doc(db, `last-seen-notifications/${lastSeen?.docs?.[0]?.id}`),
                {
                    ...lastSeen?.docs?.[0]?.data(),
                    last_seen: Timestamp.now(),
                }
            )
        }
    }

    const notificationNotSeenCount = useMemo(() => {
        if (!lastSeenTimestamp) {
            return notifications.length // Nếu chưa có `last_seen`, tất cả thông báo chưa được xem
        }

        // Lọc thông báo chưa xem (có `created_at` sau `last_seen`)
        return notifications.filter(
            (notification) =>
                notification.created_at.toMillis() >
                lastSeenTimestamp.toMillis()
        ).length
    }, [lastSeenTimestamp, notifications])

    return (
        <Popover
            interactive
            visible={showPopoverNotification}
            onClickOutside={() => setShowPopoverNotification(false)}
            render={(attrs) => (
                <PopupNotification
                    notifications={
                        data?.docs?.map((doc) => ({
                            ...(doc?.data() as NotificationItem),
                            id: doc.id,
                        })) || []
                    }
                    handleClosePopup={handleClosePopup}
                    fetchNext={() => setLimitCount((prev) => prev + 10)}
                    isHasNextPage={notifications?.length >= limitCount}
                    loading={loading}
                    error={error}
                    limitCount={limitCount}
                    {...attrs}
                />
            )}
            placement="top-start"
            appendTo={document.body}
        >
            <div
                onClick={handleClosePopup}
                className="w-9 h-9 bg-white rounded-[8px] flex items-center justify-center cursor-pointer relative"
            >
                <div className="w-5 h-5 text-bg-primary">
                    {notificationPermissionStatus === 'granted' ? (
                        notificationNotSeenCount <= 0 ? (
                            <NotificationGrantedIcons />
                        ) : (
                            <NotificationPrimaryIcons />
                        )
                    ) : (
                        <Tooltip
                            title={t('notification.enable')}
                            placement="top"
                        >
                            <NotificationOffIcons
                                onClick={() => {
                                    console.log('request permission')
                                    Notification.requestPermission().then(
                                        (permission) => {
                                            console.log(permission)
                                        }
                                    )
                                }}
                            />
                        </Tooltip>
                    )}
                </div>

                {/* {notificationNotSeenCount > 0 && (
                    <div className="bg-c-info text-bg-primary rounded-full text-xxs flex items-center justify-center w-4 h-4 absolute right-[-4px] top-[-8px]">
                        {notificationNotSeenCount}
                    </div>
                )} */}
            </div>
        </Popover>
    )
}

export default NotificationComp
